/**
 * Todoists Datum → Tag (lokale Mitternacht) + Uhrzeit. `2026-10-01` ist ein
 * ganzer Tag, `2026-10-01T15:00:00` eine Uhrzeit ohne Zone (so gemeint, wie es
 * dasteht), mit `Z` ein fester Zeitpunkt (in lokale Zeit umgerechnet).
 */
export function mapDate(date: string): { day: Date; time: string | null } | null {
  const floating = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(date)
  if (!floating) return null
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(date)) {
    const at = new Date(date)
    if (Number.isNaN(at.getTime())) return null
    const pad = (n: number) => String(n).padStart(2, '0')
    return { day: new Date(at.getFullYear(), at.getMonth(), at.getDate()), time: `${pad(at.getHours())}:${pad(at.getMinutes())}` }
  }
  const [, y, m, d, hh, mm] = floating
  return { day: new Date(Number(y), Number(m) - 1, Number(d)), time: hh ? `${hh}:${mm}` : null }
}
